import { render, staticRenderFns } from "./DepositoCrud.vue?vue&type=template&id=daa8aaec&"
import script from "./DepositoCrud.vue?vue&type=script&lang=js&"
export * from "./DepositoCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports